module.exports = __webpack_public_path__ + "static/img/live-logo.730a805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f-pc/live-logo.png
// module id = 10
// module chunks = 0